export default __webpack_public_path__ + "static/media/DACQR.cff7f912.png";